import React, { useEffect, useRef, useState } from 'react';

import Card from '../../components/Card';
import TEXT from '../../components/Text';
import UserTransactionsList from '../../components/UserTransactionsList';
import { scrollContainerIntoView } from '../../helpers/scrollIntoView';
import './style.scss';
import { useTranslation } from "react-i18next";

const Transactions = () => {
  const transactionsContainerRef = useRef();
  const { t } = useTranslation();
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  useEffect(() => {
    scrollContainerIntoView(transactionsContainerRef);
  }, []);

  return (

    <div className="admin-user-transactions" ref={transactionsContainerRef}>
      <Card>
        <TEXT.pageTitle>{t('admin.users_transactions')}</TEXT.pageTitle>
        <UserTransactionsList setSelectedCurrency={setSelectedCurrency} />
      </Card>
    </div>
  )
};

export default Transactions;
